import { render, staticRenderFns } from "./Eyebrow.vue?vue&type=template&id=af3ff330&scoped=true&"
import script from "./Eyebrow.vue?vue&type=script&lang=js&"
export * from "./Eyebrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3ff330",
  null
  
)

export default component.exports